module.exports = {"systemVersion":"1.0.48.2026083"}


//////////////////
// WEBPACK FOOTER
// ./static/js/version.json
// module id = taDY
// module chunks = 88